/* eslint-disable */
// Bundled legal HTML per locale (edit this file when updating the privacy policy).
import type {AppLocale} from 'i18n/locales'

export const privacyLegalBodyByLocale: Record<AppLocale, string> = {
  bg: `<div >
                <p class="meta">Последна актуализация: 01.05.2026</p>

                <div class="intro">
                  Настоящата Политика за поверителност („Политиката“) описва как
                  АТОМИКА ГРУП ЕООД обработва лични данни при използване на
                  Eventa.tv – за посетители, регистрирани потребители,
                  организатори и участници в събития.
                </div>

                <h3>Как да поискате изтриване на вашите данни</h3>
                <p>
                  Можете да поискате <b>изтриване на акаунта и личните данни</b>, които Eventa.tv съхранява за вас,
                  по всяко време. Това включва данни, събрани при регистрация, вход с имейл или при <b>Facebook / Meta Login</b>.
                </p>
                <p><b>Стъпки (изберете един начин):</b></p>
                <ol>
                  <li>
                    <b>Имейл:</b> изпратете съобщение на{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> или на{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> от <b>имейла, с който сте регистрирани</b>
                    (или посочете регистрирания имейл в текста). В темата или в съобщението изрично напишете, че искате{' '}
                    <b>изтриване на акаунта и свързаните лични данни в Eventa.tv</b>. Препоръчителна тема:{' '}
                    <b>„Заявка за изтриване на акаунт — Eventa.tv“</b>.
                  </li>
                  <li>
                    <b>Форма „Контакт“:</b> на уебсайта eventa.tv отворете страницата <b>Контакт / Contact</b>, опишете същото искане
                    и посочете регистрирания имейл.
                  </li>
                </ol>
                <p>
                  След проверка на самоличността (при необходимост) ще обработим заявката и ще ви отговорим в срок до{' '}
                  <b>30 календарни дни</b>, освен ако приложимият закон не изисква друг срок. Ако трябва да запазим част от
                  данните по счетоводни, данъчни или правни причини, ще ви уведомим писмено.
                </p>
                <p>
                  <b>Важно за Facebook / Meta:</b> Премахването на приложението Eventa.tv само от настройките за приложения и
                  уебсайтове на Facebook <b>не изтрива автоматично</b> вашия профил и данните в Eventa.tv на нашите сървъри.
                  За изтриване на данните, които държим ние, подайте заявка по имейл или чрез контактната форма по-горе.
                </p>

                <h3>1) Администратор и обхват</h3>
                <p>
                  Администратор на лични данни за платформата Eventa.tv е
                  <b>АТОМИКА ГРУП ЕООД</b>, ЕИК <b>205822763</b>, рег. по ЗДДС
                  <b>BG205822763</b>, адрес: България, гр. Велико Търново, ул.
                  „Никола Габровски“ 63-б.
                </p>

                <h3>
                  2) Роли при обработване (администратор/обработващ)
                </h3>
                <ul>
                  <li>
                    За акаунти, сигурност, администриране на платформата,
                    плащания/възстановявания (чрез Stripe), отчетност и
                    фактуриране: АТОМИКА ГРУП ЕООД действа като
                    <b>администратор</b>.
                  </li>
                  <li>
                    За данни на участници по конкретни събития (напр. списък с
                    участници, достъп до частна страница, сертификати): АТОМИКА
                    ГРУП ЕООД може да действа като <b>обработващ</b> от името на
                    Организатора (който е администратор за тези данни), когато
                    това е приложимо.
                  </li>
                  <li>
                    <b>Stripe</b> обработва платежни данни и картови данни като
                    самостоятелен администратор; Eventa.tv не съхранява пълни
                    данни за карти.
                  </li>
                  <li>
                    <b>Zoom</b>, <b>Google (Analytics)</b> и
                    <b>Meta (Meta Pixel)</b> са независими администратори за
                    собствените си услуги/технологии (когато се
                    използват/активират).
                  </li>
                </ul>

                <h3>3) Какви данни събираме</h3>
                <ul>
                  <li>
                    <b>Идентификационни:</b> име, фамилия, имейл, телефон (ако е
                    предоставен).
                  </li>
                  <li>
                    <b>Профилни:</b> парола (хаширана), предпочитания, език,
                    настройки.
                  </li>
                  <li>
                    <b>Данни за организация/фактуриране (за организатори):</b>
                    фирма, ЕИК, ДДС номер, адрес, данни за фактуриране, пореден
                    номер на фактура (когато е необходим за документално
                    оформяне на изплащане).
                  </li>
                  <li>
                    <b>Събитийни:</b> закупени билети, статуси
                    (регистрация/достъп/участие), достъп до частна страница,
                    издадени сертификати, закупени продукти.
                  </li>
                  <li>
                    <b>Платежни (не картови):</b> статус на плащания, суми,
                    валута, идентификатори на транзакции, данни за
                    възстановявания, данни за фактуриране. Картовите данни се
                    обработват от Stripe.
                  </li>
                  <li>
                    <b>Комуникационни:</b> кореспонденция с поддръжка, системни
                    имейли/известия.
                  </li>
                  <li>
                    <b>Технически:</b> IP адрес, логове за сигурност,
                    бисквитки/идентификатори, данни за браузър и сесии.
                  </li>
                </ul>

                <h3>4) Цели и правни основания</h3>
                <ul>
                  <li>
                    <b>Предоставяне на услугата</b> (профил, събития, частни
                    страници, достъп, сертификати) —
                    <b>изпълнение на договор</b>.
                  </li>
                  <li>
                    <b>Плащания/възстановявания/отчетност</b>, управление на
                    риск от измами/спорове — <b>изпълнение на договор</b> и/или
                    <b>легитимен интерес</b>.
                  </li>
                  <li>
                    <b>Фактуриране и счетоводство</b> —
                    <b>законово задължение</b>.
                  </li>
                  <li>
                    <b>Транзакционни имейли и напомняния</b> —
                    <b>изпълнение на договор</b> и/или <b>легитимен интерес</b>.
                  </li>
                  <li>
                    <b>Сигурност</b> и предотвратяване на злоупотреби —
                    <b>легитимен интерес</b>.
                  </li>
                  <li>
                    <b>Аналитика (Google Analytics)</b> — <b>съгласие</b> (чрез
                    банер за бисквитки), когато е активирано.
                  </li>
                  <li>
                    <b>Маркетинг/измерване (Meta Pixel)</b> — <b>съгласие</b>,
                    когато е активирано.
                  </li>
                </ul>

                <h3>5) Бисквитки и подобни технологии</h3>
                <p>
                  Използваме необходимите бисквитки за функциониране на сайта и,
                  при дадено съгласие, аналитични (Google Analytics) и рекламни
                  (Meta Pixel) бисквитки. Детайли и управление — в Политиката за
                  бисквитки на Eventa.tv.
                </p>

                <h3>6) Получатели на данни</h3>
                <ul>
                  <li>
                    <b>Stripe</b> — обработка на плащания, възстановявания,
                    изплащания и свързани отчетни данни.
                  </li>
                  <li>
                    <b>Zoom</b> — провеждане на онлайн събития (когато се
                    използва).
                  </li>
                  <li>
                    <b>
                      Доставчици на инфраструктура/хостинг/имейл/SMS/поддръжка
                    </b>
                    — за предоставяне и поддръжка на услугата.
                  </li>
                  <li>
                    <b>Google/Meta</b> — при дадено съгласие за
                    аналитични/рекламни цели (когато са активирани).
                  </li>
                  <li>
                    <b>Организаторът</b> — получава данни за участниците по
                    своето събитие (напр. име/имейл/статус), за да проведе
                    събитието и да предостави достъп/материали/сертификати.
                  </li>
                  <li>
                    <b>Компетентни органи</b> — при законово изискване.
                  </li>
                </ul>

                <h3>7) Международни трансфери</h3>
                <p>
                  Някои получатели (напр. Stripe, Zoom, Google, Meta) могат да
                  обработват данни извън ЕС/ЕИП. При такива трансфери се
                  прилагат подходящи гаранции съгласно GDPR (напр. Стандартни
                  договорни клаузи).
                </p>

                <h3>8) Срокове за съхранение</h3>
                <ul>
                  <li>
                    <b>Данни по акаунт</b> — докато акаунтът е активен и до 3
                    години след закриване за защита при претенции, освен ако
                    закон изисква друго.
                  </li>
                  <li>
                    <b>Счетоводни/данъчни документи</b> (фактури, транзакции) —
                    съгласно българското законодателство (обичайно до 10
                    години).
                  </li>
                  <li>
                    <b>Логове за сигурност</b> — обичайно до 12 месеца, освен
                    при инцидент/спор.
                  </li>
                  <li>
                    <b>Маркетинг (съгласие)</b> — до оттегляне на съгласието.
                  </li>
                </ul>

                <h3>9) Сигурност</h3>
                <p>
                  Прилагаме технически и организационни мерки (шифроване на
                  трафика, контрол на достъпа, мониторинг и др.). Въпреки това,
                  нито един метод не гарантира абсолютна сигурност.
                </p>

                <h3>10) Вашите права</h3>
                <ul>
                  <li>Право на достъп и копие от данните.</li>
                  <li>Право на коригиране на неточни/непълни данни.</li>
                  <li>
                    Право на изтриване („да бъдете забравени“) в предвидените от
                    закона случаи.
                  </li>
                  <li>Право на ограничаване на обработването.</li>
                  <li>Право на преносимост.</li>
                  <li>
                    Право на възражение (вкл. срещу маркетинг, когато е
                    приложимо).
                  </li>
                  <li>
                    Право на оттегляне на съгласие по всяко време, когато
                    обработването се базира на съгласие.
                  </li>
                </ul>
                <h4>Подробности: изтриване по GDPR</h4>
                <p>
                  Имате право да поискате изтриване на личните данни, свързани с
                  вашия акаунт в Eventa.tv („право да бъдете забравени“), когато
                  приложимото право го позволява по GDPR. Начините за заявка са
                  същите като в секцията <b>„Как да поискате изтриване на вашите данни“</b> в началото на тази политика.
                </p>
                <p><b>Напомняне — как да подадете искане:</b></p>
                <ol>
                  <li>
                    <b>Имейл:</b> Изпратете имейл на{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> или на{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> от
                    имейл адреса, с който сте регистрирани в платформата (или
                    посочете регистрирания имейл в текста на искането). В темата
                    или текста ясно посочете, че искате{' '}
                    <b>изтриване на акаунта и свързаните лични данни</b>.
                  </li>
                  <li>
                    <b>Секция „Контакт“:</b> Можете да използвате секцията
                    „Контакт“ на eventa.tv и да опишете искането за изтриване.
                  </li>
                </ol>
                <p>
                  След потвърждаване на самоличността ви (при необходимост) ще
                  обработим искането и ще ви отговорим в разумен срок — обикновено
                  до <b>30 календарни дни</b>, освен ако законът не изисква или позволява
                  друг срок. Ако трябва да запазим определени данни по
                  счетоводни, данъчни или правни причини, ще ви информираме.
                </p>
                <p>
                  Ако сте влизали чрез Facebook или друг доставчик, можете да
                  управлявате приложението и достъпа от настройките за
                  поверителност на съответната услуга; <b>това не замества</b> заявка към нас за изтриване на данните в Eventa.tv — използвайте имейл или формата „Контакт“ по-горе.
                </p>
                <p>
                  За упражняване на останалите права: използвайте секцията
                  „Контакт“ на eventa.tv или изпратете писмено запитване до адреса
                  по-горе. За данни, обработвани от Организатора като
                  администратор (напр. по конкретно събитие), обърнете се
                  директно към него.
                </p>

                <h3>11) Жалби</h3>
                <p>
                  Имате право да подадете жалба до Комисия за защита на личните
                  данни (КЗЛД), www.cpdp.bg. Препоръчваме първо да се свържете с
                  нас, за да съдействаме.
                </p>

                <h3>12) Данни на деца</h3>
                <p>
                  Платформата не е насочена към деца под 16 години. Ако считате,
                  че сме събрали данни за лице под 16 г. без валидно основание,
                  свържете се с нас за предприемане на мерки.
                </p>

                <h3>13) Промени</h3>
                <p>
                  Можем да актуализираме настоящата Политика. Промените се
                  публикуват на тази страница, а при съществени изменения може
                  да уведомим чрез платформата/имейл.
                </p>

                <h3>14) Контакт</h3>
                <p>
                  Въпроси относно поверителността: секцията „Контакт“ на
                  eventa.tv или по поща: АТОМИКА ГРУП ЕООД, България, гр. Велико
                  Търново, ул. „Никола Габровски“ 63-б.
                </p>
              </div>`,
  en: `<div >
                <p class="meta">Last updated: 1 May 2026</p>

                <div class="intro">
                  This Privacy Policy („Policy”) describes how ATOMICA GROUP Ltd processes
                  personal data when using Eventa.tv—for visitors, registered users, organisers and
                  event participants.
                </div>

                <h3>How to request deletion of your data</h3>
                <p>
                  You may request <b>deletion of your account and the personal data</b> Eventa.tv stores about you at any
                  time. This includes data collected when you register, sign in with email, or use <b>Facebook / Meta Login</b>.
                </p>
                <p><b>Steps (choose one method):</b></p>
                <ol>
                  <li>
                    <b>Email:</b> send a message to{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> or to{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> from the <b>email address registered on your
                    Eventa.tv account</b> (or clearly state that registered email in the body). In the subject or message,
                    explicitly request <b>deletion of your account and related personal data held by Eventa.tv</b>.
                    Suggested subject line: <b>“Account data deletion request — Eventa.tv”</b>.
                  </li>
                  <li>
                    <b>Contact form:</b> on eventa.tv open the <b>Contact</b> page, describe the same request, and include your
                    registered email address.
                  </li>
                </ol>
                <p>
                  After we verify your identity (if needed), we will process the request and respond within{' '}
                  <b>30 calendar days</b>, unless applicable law requires a different period. If we must retain certain data
                  for accounting, tax, or legal reasons, we will inform you in writing.
                </p>
                <p>
                  <b>Facebook / Meta:</b> Removing the Eventa.tv app only from your Facebook <b>Apps and Websites</b>{' '}
                  settings <b>does not automatically delete</b> your Eventa.tv profile or the data we hold on our servers.
                  To delete data we store, submit a request by email or via the contact form above.
                </p>

                <h3>1) Controller and scope</h3>
                <p>
                  The controller of personal data for the Eventa.tv platform is <b>ATOMICA GROUP
                  Ltd</b>, company registration number (EIK) <b>205822763</b>, VAT <b>BG205822763</b>,
                  address: Bulgaria, Veliko Tarnovo, 63-b Nikola Gabrovski Street.
                </p>

                <h3>
                  2) Roles in processing (controller/processor)
                </h3>
                <ul>
                  <li>
                    For accounts, security, administration of the platform,
                    payments/refunds (via Stripe), reporting and invoicing: ATOMICA GROUP Ltd acts as
                    <b>controller</b>.
                  </li>
                  <li>
                    For data relating to participants in specific events (e.g. participant lists,
                    access to the private page, certificates): ATOMICA GROUP Ltd may act as
                    <b>processor</b> on behalf of the Organiser (who is controller for such data),
                    where applicable.
                  </li>
                  <li>
                    <b>Stripe</b> processes payment data and card data as an independent controller;
                    Eventa.tv does not store full card data.
                  </li>
                  <li>
                    <b>Zoom</b>, <b>Google (Analytics)</b> and <b>Meta (Meta Pixel)</b> are independent
                    controllers for their own services/technologies (when used/activated).
                  </li>
                </ul>

                <h3>3) What data we collect</h3>
                <ul>
                  <li>
                    <b>Identification:</b> first name, last name, email, phone (if provided).
                  </li>
                  <li>
                    <b>Profile:</b> password (hashed), preferences, language, settings.
                  </li>
                  <li>
                    <b>Organisation/invoicing data (for organisers):</b> company name, registration
                    number, VAT number, address, invoicing details, sequential invoice number (when
                    required for documentation of payout).
                  </li>
                  <li>
                    <b>Event-related:</b> purchased tickets, statuses (registration/access/participation),
                    access to private page, issued certificates, purchased products.
                  </li>
                  <li>
                    <b>Payment (non-card):</b> payment status, amounts, currency, transaction identifiers,
                    refund data, invoicing data. Card data are processed by Stripe.
                  </li>
                  <li>
                    <b>Communications:</b> correspondence with support, system emails/notifications.
                  </li>
                  <li>
                    <b>Technical:</b> IP address, security logs, cookies/identifiers, browser and session data.
                  </li>
                </ul>

                <h3>4) Purposes and legal bases</h3>
                <ul>
                  <li>
                    <b>Providing the service</b> (profile, events, private pages, access, certificates)—
                    <b>performance of a contract</b>.
                  </li>
                  <li>
                    <b>Payments/refunds/reporting</b>, fraud/dispute risk management—<b>performance of a
                    contract</b> and/or <b>legitimate interest</b>.
                  </li>
                  <li>
                    <b>Invoicing and accounting</b>—<b>legal obligation</b>.
                  </li>
                  <li>
                    <b>Transactional emails and reminders</b>—<b>performance of a contract</b> and/or
                    <b>legitimate interest</b>.
                  </li>
                  <li>
                    <b>Security</b> and abuse prevention—<b>legitimate interest</b>.
                  </li>
                  <li>
                    <b>Analytics (Google Analytics)</b>—<b>consent</b> (via cookie banner), when activated.
                  </li>
                  <li>
                    <b>Marketing/measurement (Meta Pixel)</b>—<b>consent</b>, when activated.
                  </li>
                </ul>

                <h3>5) Cookies and similar technologies</h3>
                <p>
                  We use necessary cookies for the site to function and, where you consent, analytics
                  (Google Analytics) and advertising (Meta Pixel) cookies. Details and management—in
                  the Eventa.tv Cookie Policy.
                </p>

                <h3>6) Recipients of data</h3>
                <ul>
                  <li>
                    <b>Stripe</b>—processing of payments, refunds, payouts and related reporting data.
                  </li>
                  <li>
                    <b>Zoom</b>—conducting online events (when used).
                  </li>
                  <li>
                    <b>
                      Infrastructure/hosting/email/SMS/support providers
                    </b>
                    —for delivering and maintaining the service.
                  </li>
                  <li>
                    <b>Google/Meta</b>—where consent is given for analytics/marketing purposes (when
                    activated).
                  </li>
                  <li>
                    <b>Organiser</b>—receives data about participants to their event (e.g. name/email/status)
                    in order to run the event and provide access/materials/certificates.
                  </li>
                  <li>
                    <b>Competent authorities</b>—where required by law.
                  </li>
                </ul>

                <h3>7) International transfers</h3>
                <p>
                  Some recipients (e.g. Stripe, Zoom, Google, Meta) may process data outside the EU/EEA.
                  For such transfers appropriate safeguards under the GDPR apply (e.g. Standard Contractual
                  Clauses).
                </p>

                <h3>8) Retention periods</h3>
                <ul>
                  <li>
                    <b>Account data</b>—while the account is active and for up to 3 years after closure for
                    protection against claims, unless the law requires otherwise.
                  </li>
                  <li>
                    <b>Accounting/tax documents</b> (invoices, transactions)—in accordance with Bulgarian law
                    (typically up to 10 years).
                  </li>
                  <li>
                    <b>Security logs</b>—typically up to 12 months, unless incident/dispute.
                  </li>
                  <li>
                    <b>Marketing (consent)</b>—until consent is withdrawn.
                  </li>
                </ul>

                <h3>9) Security</h3>
                <p>
                  We apply technical and organisational measures (encryption of traffic, access control,
                  monitoring, etc.). No method guarantees absolute security.
                </p>

                <h3>10) Your rights</h3>
                <ul>
                  <li>Right of access and copy of data.</li>
                  <li>Right to rectification of inaccurate/incomplete data.</li>
                  <li>
                    Right to erasure („to be forgotten”) in cases provided by law.
                  </li>
                  <li>Right to restriction of processing.</li>
                  <li>Right to data portability.</li>
                  <li>
                    Right to object (including to marketing, where applicable).
                  </li>
                  <li>
                    Right to withdraw consent at any time where processing is based on consent.
                  </li>
                </ul>
                <h4>Further detail: erasure under the GDPR</h4>
                <p>
                  You may request deletion of personal data associated with your Eventa.tv account (“right to be
                  forgotten”) where applicable under the GDPR. The ways to submit a request are the same as in the section{' '}
                  <b>“How to request deletion of your data”</b> at the beginning of this Policy.
                </p>
                <p><b>Reminder — how to submit a request:</b></p>
                <ol>
                  <li>
                    <b>Email:</b> Send an email to{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> or to{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> from the email address registered on your
                    account (or state your registered email in the request). Clearly indicate in the subject or body
                    that you want your <b>account and related personal data deleted</b>.
                  </li>
                  <li>
                    <b>Contact section:</b> You may also use the “Contact” section on eventa.tv and describe your
                    deletion request there.
                  </li>
                </ol>
                <p>
                  After we verify your identity (if needed), we will process your request and respond within a
                  reasonable period—typically within <b>30 calendar days</b>, unless the law requires or allows a different
                  timeframe. If we must retain certain data for accounting, tax, or legal reasons, we will inform you.
                </p>
                <p>
                  If you signed in with Facebook or another provider, you may also manage the app and permissions in
                  that service’s privacy settings; <b>that does not replace</b> a request to us to delete data held in
                  Eventa.tv—use email or the Contact form above.
                </p>
                <p>
                  To exercise your other rights: use the “Contact” section on eventa.tv or send a written request to the
                  address above. For data processed by the Organiser as controller (e.g. for a specific event), contact
                  them directly.
                </p>

                <h3>11) Complaints</h3>
                <p>
                  You have the right to lodge a complaint with the Commission for Personal Data Protection
                  (CPDP), www.cpdp.bg. We recommend contacting us first so we can assist.
                </p>

                <h3>12) Children’s data</h3>
                <p>
                  The Platform is not directed at children under 16. If you believe we have collected data on
                  a person under 16 without a valid basis, contact us so we can take appropriate steps.
                </p>

                <h3>13) Changes</h3>
                <p>
                  We may update this Policy. Changes are published on this page; for material changes we may
                  notify you via the platform/email.
                </p>

                <h3>14) Contact</h3>
                <p>
                  Questions about privacy: the „Contact” section on eventa.tv or by post: ATOMICA GROUP Ltd,
                  Bulgaria, Veliko Tarnovo, 63-b Nikola Gabrovski Street.
                </p>
              </div>`,
  de: `<div >
                <p class="meta">Letzte Aktualisierung: 1. Mai 2026</p>

                <div class="intro">
                  Diese Datenschutzerklärung („Erklärung”) beschreibt, wie ATOMICA GROUP Ltd personenbezogene
                  Daten bei Nutzung von Eventa.tv verarbeitet—für Besucher, registrierte Nutzer, Veranstalter
                  und Teilnehmende an Veranstaltungen.
                </div>

                <h3>Wie Sie die Löschung Ihrer Daten beantragen</h3>
                <p>
                  Sie können jederzeit die <b>Löschung Ihres Kontos und der personenbezogenen Daten</b> beantragen, die
                  Eventa.tv über Sie speichert. Dazu gehören Daten aus Registrierung, Anmeldung per E-Mail oder bei Nutzung von{' '}
                  <b>Facebook / Meta Login</b>.
                </p>
                <p><b>Schritte (wählen Sie eine Methode):</b></p>
                <ol>
                  <li>
                    <b>E-Mail:</b> Senden Sie eine Nachricht an{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> oder an{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> von der <b>bei uns registrierten E-Mail-Adresse</b>
                    (oder geben Sie die registrierte Adresse im Text an). Geben Sie im Betreff oder Text ausdrücklich an,
                    dass Sie die <b>Löschung Ihres Kontos und der zugehörigen bei Eventa.tv gespeicherten Daten</b> wünschen.
                    Betreff-Vorschlag: <b>„Antrag auf Kontolöschung — Eventa.tv“</b>.
                  </li>
                  <li>
                    <b>Kontaktformular:</b> Öffnen Sie auf eventa.tv die Seite <b>Kontakt</b>, beschreiben Sie denselben Antrag
                    und nennen Sie Ihre registrierte E-Mail-Adresse.
                  </li>
                </ol>
                <p>
                  Nach Identitätsprüfung (falls erforderlich) bearbeiten wir den Antrag und antworten innerhalb von{' '}
                  <b>30 Kalendertagen</b>, sofern das anwendbare Recht keine andere Frist vorsieht. Müssen wir bestimmte Daten
                  aus buchführungs-, steuer- oder rechtlichen Gründen aufbewahren, informieren wir Sie schriftlich.
                </p>
                <p>
                  <b>Facebook / Meta:</b> Wenn Sie die Eventa.tv-App nur in den Facebook-Einstellungen unter{' '}
                  <b>Apps und Websites</b> entfernen, werden Ihr Eventa.tv-Profil und die Daten auf unseren Servern{' '}
                  <b>nicht automatisch gelöscht</b>. Zur Löschung der von uns gespeicherten Daten senden Sie uns einen Antrag per
                  E-Mail oder über das Kontaktformular oben.
                </p>

                <h3>1) Verantwortlicher und Geltungsbereich</h3>
                <p>
                  Verantwortlicher für personenbezogene Daten der Plattform Eventa.tv ist <b>ATOMICA GROUP
                  Ltd</b>, Eintragungsnummer (EIK) <b>205822763</b>, USt-IdNr. <b>BG205822763</b>, Adresse:
                  Bulgarien, Weliko Tarnowo, Uliza „Nikola Gabrowski“ 63-b.
                </p>

                <h3>
                  2) Rollen bei der Verarbeitung (Verantwortlicher/Auftragsverarbeiter)
                </h3>
                <ul>
                  <li>
                    Für Konten, Sicherheit, Plattformverwaltung, Zahlungen/Rückerstattungen (über Stripe),
                    Reporting und Rechnungsstellung: ATOMICA GROUP Ltd handelt als <b>Verantwortlicher</b>.
                  </li>
                  <li>
                    Für Daten von Teilnehmenden zu bestimmten Veranstaltungen (z. B. Teilnehmendenlisten,
                    Zugang zur privaten Seite, Zertifikate): ATOMICA GROUP Ltd kann als <b>Auftragsverarbeiter</b>
                    im Auftrag des Veranstalters (der für diese Daten Verantwortlicher ist) handeln, soweit
                    anwendbar.
                  </li>
                  <li>
                    <b>Stripe</b> verarbeitet Zahlungs- und Kartendaten als eigenverantwortlicher
                    Verantwortlicher; Eventa.tv speichert keine vollständigen Kartendaten.
                  </li>
                  <li>
                    <b>Zoom</b>, <b>Google (Analytics)</b> und <b>Meta (Meta Pixel)</b> sind eigenverantwortliche
                    Verantwortliche für ihre eigenen Dienste/Technologien (sofern genutzt/aktiviert).
                  </li>
                </ul>

                <h3>3) Welche Daten wir erheben</h3>
                <ul>
                  <li>
                    <b>Identifikation:</b> Vor- und Nachname, E-Mail, Telefon (falls angegeben).
                  </li>
                  <li>
                    <b>Profil:</b> Passwort (gehasht), Präferenzen, Sprache, Einstellungen.
                  </li>
                  <li>
                    <b>Organisations-/Rechnungsdaten (für Veranstalter):</b> Firma, EIK, USt-IdNr., Adresse,
                    Rechnungsdaten, fortlaufende Rechnungsnummer (soweit für die Auszahlungsdokumentation
                    erforderlich).
                  </li>
                  <li>
                    <b>Veranstaltungsbezogen:</b> gekaufte Tickets, Status (Registrierung/Zugang/Teilnahme),
                    Zugang zur privaten Seite, ausgestellte Zertifikate, gekaufte Produkte.
                  </li>
                  <li>
                    <b>Zahlungsdaten (nicht Kartendaten):</b> Zahlungsstatus, Beträge, Währung,
                    Transaktionskennungen, Erstattungsdaten, Rechnungsdaten. Kartendaten werden von Stripe
                    verarbeitet.
                  </li>
                  <li>
                    <b>Kommunikation:</b> Korrespondenz mit dem Support, System-E-Mails/Benachrichtigungen.
                  </li>
                  <li>
                    <b>Technisch:</b> IP-Adresse, Sicherheitsprotokolle, Cookies/Kennungen, Browser- und
                    Sitzungsdaten.
                  </li>
                </ul>

                <h3>4) Zwecke und Rechtsgrundlagen</h3>
                <ul>
                  <li>
                    <b>Bereitstellung der Leistung</b> (Profil, Veranstaltungen, private Seiten, Zugang,
                    Zertifikate)—<b>Vertragserfüllung</b>.
                  </li>
                  <li>
                    <b>Zahlungen/Erstattungen/Reporting</b>, Risikomanagement Betrug/Streitigkeiten—<b>Vertragserfüllung</b>
                    und/oder <b>berechtigtes Interesse</b>.
                  </li>
                  <li>
                    <b>Rechnungsstellung und Buchführung</b>—<b>rechtliche Verpflichtung</b>.
                  </li>
                  <li>
                    <b>Transaktions-E-Mails und Erinnerungen</b>—<b>Vertragserfüllung</b> und/oder
                    <b>berechtigtes Interesse</b>.
                  </li>
                  <li>
                    <b>Sicherheit</b> und Missbrauchsprävention—<b>berechtigtes Interesse</b>.
                  </li>
                  <li>
                    <b>Analytik (Google Analytics)</b>—<b>Einwilligung</b> (über Cookie-Banner), wenn aktiviert.
                  </li>
                  <li>
                    <b>Marketing/Messung (Meta Pixel)</b>—<b>Einwilligung</b>, wenn aktiviert.
                  </li>
                </ul>

                <h3>5) Cookies und ähnliche Technologien</h3>
                <p>
                  Wir verwenden notwendige Cookies für den Betrieb der Website und bei Einwilligung analytische
                  (Google Analytics) und Werbe- (Meta Pixel) Cookies. Details und Verwaltung—in der Cookie-
                  Richtlinie von Eventa.tv.
                </p>

                <h3>6) Empfänger von Daten</h3>
                <ul>
                  <li>
                    <b>Stripe</b>—Verarbeitung von Zahlungen, Erstattungen, Auszahlungen und zugehörigen
                    Reportingdaten.
                  </li>
                  <li>
                    <b>Zoom</b>—Durchführung von Online-Veranstaltungen (bei Nutzung).
                  </li>
                  <li>
                    <b>
                      Infrastruktur-/Hosting-/E-Mail-/SMS-/Support-Anbieter
                    </b>
                    —zur Bereitstellung und Wartung der Leistung.
                  </li>
                  <li>
                    <b>Google/Meta</b>—bei Einwilligung für analytische/Werbezwecke (wenn aktiviert).
                  </li>
                  <li>
                    <b>Veranstalter</b>—erhält Daten zu Teilnehmenden seiner Veranstaltung (z. B. Name/E-Mail/
                    Status), um die Veranstaltung durchzuführen und Zugang/Materialien/Zertifikate bereitzustellen.
                  </li>
                  <li>
                    <b>Zuständige Behörden</b>—bei gesetzlicher Verpflichtung.
                  </li>
                </ul>

                <h3>7) Internationale Übermittlungen</h3>
                <p>
                  Einige Empfänger (z. B. Stripe, Zoom, Google, Meta) können Daten außerhalb der EU/EWR
                  verarbeiten. Für solche Übermittlungen gelten geeignete Garantien gemäß DSGVO (z. B.
                  Standardvertragsklauseln).
                </p>

                <h3>8) Aufbewahrungsfristen</h3>
                <ul>
                  <li>
                    <b>Kontodaten</b>—solange das Konto aktiv ist und bis zu 3 Jahre nach Schließung zum Schutz
                    vor Ansprüchen, sofern das Gesetz nichts anderes vorsieht.
                  </li>
                  <li>
                    <b>Buchführungs-/Steuerunterlagen</b> (Rechnungen, Transaktionen)—gemäß bulgarischem Recht
                    (üblicherweise bis zu 10 Jahre).
                  </li>
                  <li>
                    <b>Sicherheitsprotokolle</b>—üblicherweise bis zu 12 Monate, außer bei Vorfall/Streit.
                  </li>
                  <li>
                    <b>Marketing (Einwilligung)</b>—bis zum Widerruf der Einwilligung.
                  </li>
                </ul>

                <h3>9) Sicherheit</h3>
                <p>
                  Wir wenden technische und organisatorische Maßnahmen an (Verschlüsselung des Datenverkehrs,
                  Zugriffskontrolle, Überwachung usw.). Keine Methode garantiert absolute Sicherheit.
                </p>

                <h3>10) Ihre Rechte</h3>
                <ul>
                  <li>Recht auf Auskunft und Kopie der Daten.</li>
                  <li>Recht auf Berichtigung unrichtiger/unvollständiger Daten.</li>
                  <li>
                    Recht auf Löschung („Recht auf Vergessenwerden”) in den gesetzlich vorgesehenen Fällen.
                  </li>
                  <li>Recht auf Einschränkung der Verarbeitung.</li>
                  <li>Recht auf Datenübertragbarkeit.</li>
                  <li>
                    Recht auf Widerspruch (einschließlich gegen Marketing, soweit anwendbar).
                  </li>
                  <li>
                    Recht auf Widerruf der Einwilligung jederzeit, wenn die Verarbeitung auf Einwilligung beruht.
                  </li>
                </ul>
                <h4>Weitere Einzelheiten: Löschung nach DSGVO</h4>
                <p>
                  Sie können die Löschung der mit Ihrem Eventa.tv-Konto verbundenen personenbezogenen Daten beantragen
                  („Recht auf Vergessenwerden”), soweit nach der DSGVO anwendbar. Die Antragswege entsprechen der Sektion{' '}
                  <b>„Wie Sie die Löschung Ihrer Daten beantragen“</b> zu Beginn dieser Erklärung.
                </p>
                <p><b>Erinnerung — so stellen Sie einen Antrag:</b></p>
                <ol>
                  <li>
                    <b>E-Mail:</b> Senden Sie eine E-Mail an{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> oder an{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> von der bei uns registrierten E-Mail-Adresse
                    (oder geben Sie die registrierte Adresse im Antrag an). Geben Sie im Betreff oder Text deutlich an,
                    dass Sie die <b>Löschung Ihres Kontos und der zugehörigen personenbezogenen Daten</b> wünschen.
                  </li>
                  <li>
                    <b>Kontaktbereich:</b> Sie können auch den Bereich „Kontakt“ auf eventa.tv nutzen und dort Ihren
                    Löschantrag beschreiben.
                  </li>
                </ol>
                <p>
                  Nach Identitätsprüfung (falls erforderlich) bearbeiten wir den Antrag und antworten in angemessener
                  Frist—in der Regel innerhalb von <b>30 Kalendertagen</b>, sofern das Gesetz keine andere Frist vorsieht oder
                  zulässt. Müssen wir bestimmte Daten aus buchführungs-, steuer- oder rechtlichen Gründen aufbewahren,
                  informieren wir Sie.
                </p>
                <p>
                  Wenn Sie sich mit Facebook oder einem anderen Anbieter angemeldet haben, können Sie die App und
                  Berechtigungen auch in den Datenschutzeinstellungen dieses Dienstes verwalten; <b>das ersetzt keinen</b>{' '}
                  Antrag an uns zur Löschung der bei Eventa.tv gespeicherten Daten—nutzen Sie E-Mail oder das Kontaktformular oben.
                </p>
                <p>
                  Zur Ausübung Ihrer übrigen Rechte: Nutzen Sie den Bereich „Kontakt“ auf eventa.tv oder senden Sie eine
                  schriftliche Anfrage an die oben genannte Adresse. Für Daten, die vom Veranstalter als Verantwortlicher
                  verarbeitet werden (z. B. zu einer bestimmten Veranstaltung), wenden Sie sich direkt an ihn.
                </p>

                <h3>11) Beschwerden</h3>
                <p>
                  Sie haben das Recht, eine Beschwerde bei der Kommission für den Schutz personenbezogener Daten
                  (CPDP), www.cpdp.bg, einzureichen. Wir empfehlen, sich zuerst an uns zu wenden.
                </p>

                <h3>12) Daten von Kindern</h3>
                <p>
                  Die Plattform richtet sich nicht an Kinder unter 16 Jahren. Wenn Sie glauben, dass wir ohne
                  gültige Grundlage Daten zu einer Person unter 16 erhoben haben, kontaktieren Sie uns.
                </p>

                <h3>13) Änderungen</h3>
                <p>
                  Wir können diese Erklärung aktualisieren. Änderungen werden auf dieser Seite veröffentlicht; bei
                  wesentlichen Änderungen können wir über die Plattform/E-Mail informieren.
                </p>

                <h3>14) Kontakt</h3>
                <p>
                  Fragen zum Datenschutz: Bereich „Kontakt“ auf eventa.tv oder postalisch: ATOMICA GROUP Ltd,
                  Bulgarien, Weliko Tarnowo, Uliza „Nikola Gabrowski“ 63-b.
                </p>
              </div>`,
  tr: `<div >
                <p class="meta">Son güncelleme: 1 Mayıs 2026</p>

                <div class="intro">
                  İşbu Gizlilik Politikası („Politika”), ziyaretçiler, kayıtlı kullanıcılar, düzenleyiciler ve
                  etkinlik katılımcıları için Eventa.tv kullanılırken ATOMICA GROUP Ltd’nin kişisel verileri nasıl
                  işlediğini açıklar.
                </div>

                <h3>Verilerinizin silinmesini nasıl talep edersiniz</h3>
                <p>
                  Eventa.tv’nin sizin hakkınızda sakladığı <b>hesabınızın ve kişisel verilerinizin silinmesini</b> istediğiniz
                  her zaman bize başvurabilirsiniz. Bu; kayıt, e-posta ile giriş veya <b>Facebook / Meta ile giriş</b> sırasında
                  toplanan verileri kapsar.
                </p>
                <p><b>Adımlar (bir yöntem seçin):</b></p>
                <ol>
                  <li>
                    <b>E-posta:</b>{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> veya{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> adresine, hesabınızda kayıtlı <b>e-posta adresinizden</b>
                    (veya metinde kayıtlı e-postayı açıkça belirterek) yazın. Konu veya mesajda{' '}
                    <b>Eventa.tv hesabınızın ve ilişkili kişisel verilerinizin silinmesini</b> istediğinizi açıkça yazın.
                    Önerilen konu: <b>„Hesap ve veri silme talebi — Eventa.tv”</b>.
                  </li>
                  <li>
                    <b>İletişim formu:</b> eventa.tv üzerinde <b>İletişim</b> sayfasını açın, aynı talebi yazın ve kayıtlı
                    e-posta adresinizi belirtin.
                  </li>
                </ol>
                <p>
                  Kimliğinizi doğruladıktan sonra (gerekirse) talebi işler ve yürürlükteki mevzuata göre genellikle{' '}
                  <b>30 takvim günü</b> içinde yanıtlarız. Muhasebe, vergi veya hukuki nedenlerle belirli verileri saklamamız
                  gerekirse sizi yazılı olarak bilgilendiririz.
                </p>
                <p>
                  <b>Facebook / Meta:</b> Eventa.tv uygulamasını yalnızca Facebook’taki <b>Uygulamalar ve web siteleri</b>{' '}
                  ayarlarından kaldırmak, Eventa.tv profilinizi ve sunucularımızda tuttuğumuz verileri{' '}
                  <b>otomatik olarak silmez</b>. Bizde tutulan verilerin silinmesi için yukarıdaki e-posta veya iletişim formuyla
                  talepte bulunun.
                </p>

                <h3>1) Veri sorumlusu ve kapsam</h3>
                <p>
                  Eventa.tv platformunun kişisel veri sorumlusu <b>ATOMICA GROUP Ltd</b>; sicil numarası (EIK)
                  <b>205822763</b>, KDV <b>BG205822763</b>, adres: Bulgaristan, Veliko Tırnovo, Nikola Gabrovski
                  Sokak 63-b.
                </p>

                <h3>
                  2) İşleme rolleri (sorumlu/işleyen)
                </h3>
                <ul>
                  <li>
                    Hesaplar, güvenlik, platform yönetimi, ödemeler/iadeler (Stripe üzerinden), raporlama ve
                    faturalama için: ATOMICA GROUP Ltd <b>veri sorumlusu</b> olarak hareket eder.
                  </li>
                  <li>
                    Belirli etkinliklere ilişkin katılımcı verileri için (ör. katılımcı listeleri, özel sayfaya
                    erişim, sertifikalar): ATOMICA GROUP Ltd, uygun olduğunda <b>işleyen</b> olarak (bu veriler
                    için veri sorumlusu olan Düzenleyici adına) hareket edebilir.
                  </li>
                  <li>
                    <b>Stripe</b> ödeme ve kart verilerini bağımsız veri sorumlusu olarak işler; Eventa.tv tam
                    kart verilerini saklamaz.
                  </li>
                  <li>
                    <b>Zoom</b>, <b>Google (Analytics)</b> ve <b>Meta (Meta Pixel)</b> kendi hizmetleri/teknolojileri
                    için bağımsız veri sorumlularıdır (kullanıldığında/etkinleştirildiğinde).
                  </li>
                </ul>

                <h3>3) Hangi verileri topluyoruz</h3>
                <ul>
                  <li>
                    <b>Kimlik:</b> ad, soyad, e-posta, telefon (sağlanmışsa).
                  </li>
                  <li>
                    <b>Profil:</b> şifre (özetlenmiş), tercihler, dil, ayarlar.
                  </li>
                  <li>
                    <b>Kuruluş/faturalama (düzenleyiciler için):</b> şirket, EIK, KDV numarası, adres, faturalama
                    bilgileri, ödeme belgelendirmesi için gerekli olduğunda ardışık fatura numarası.
                  </li>
                  <li>
                    <b>Etkinlikle ilgili:</b> satın alınan biletler, durumlar (kayıt/erişim/katılım), özel sayfaya
                    erişim, düzenlenen sertifikalar, satın alınan ürünler.
                  </li>
                  <li>
                    <b>Ödeme (kart dışı):</b> ödeme durumu, tutarlar, para birimi, işlem tanımlayıcıları, iade
                    verileri, faturalama verileri. Kart verileri Stripe tarafından işlenir.
                  </li>
                  <li>
                    <b>İletişim:</b> destek yazışması, sistem e-postaları/bildirimleri.
                  </li>
                  <li>
                    <b>Teknik:</b> IP adresi, güvenlik günlükleri, çerezler/tanımlayıcılar, tarayıcı ve oturum verileri.
                  </li>
                </ul>

                <h3>4) Amaçlar ve hukuki dayanaklar</h3>
                <ul>
                  <li>
                    <b>Hizmetin sunulması</b> (profil, etkinlikler, özel sayfalar, erişim, sertifikalar)—
                    <b>sözleşmenin ifası</b>.
                  </li>
                  <li>
                    <b>Ödemeler/iadeler/raporlama</b>, dolandırıcılık/itiraz riski yönetimi—<b>sözleşmenin ifası</b>
                    ve/veya <b>meşru menfaat</b>.
                  </li>
                  <li>
                    <b>Faturalama ve muhasebe</b>—<b>yasal yükümlülük</b>.
                  </li>
                  <li>
                    <b>İşlemsel e-postalar ve hatırlatmalar</b>—<b>sözleşmenin ifası</b> ve/veya <b>meşru menfaat</b>.
                  </li>
                  <li>
                    <b>Güvenlik</b> ve kötüye kullanımın önlenmesi—<b>meşru menfaat</b>.
                  </li>
                  <li>
                    <b>Analitik (Google Analytics)</b>—etkinleştirildiğinde çerez bildirimiyle <b>açık rıza</b>.
                  </li>
                  <li>
                    <b>Pazarlama/ölçüm (Meta Pixel)</b>—etkinleştirildiğinde <b>açık rıza</b>.
                  </li>
                </ul>

                <h3>5) Çerezler ve benzeri teknolojiler</h3>
                <p>
                  Sitenin çalışması için gerekli çerezleri kullanırız; verdiğiniz rızaya bağlı olarak analitik
                  (Google Analytics) ve reklam (Meta Pixel) çerezleri. Ayrıntılar ve yönetim — Eventa.tv Çerez
                  Politikasında.
                </p>

                <h3>6) Veri alıcıları</h3>
                <ul>
                  <li>
                    <b>Stripe</b>—ödemeler, iadeler, ödemeler ve ilgili raporlama verilerinin işlenmesi.
                  </li>
                  <li>
                    <b>Zoom</b>—çevrim içi etkinliklerin yürütülmesi (kullanıldığında).
                  </li>
                  <li>
                    <b>
                      Altyapı/barındırma/e-posta/SMS/destek sağlayıcıları
                    </b>
                    —hizmetin sunumu ve bakımı için.
                  </li>
                  <li>
                    <b>Google/Meta</b>—analitik/pazarlama için rıza verildiğinde (etkinleştirildiğinde).
                  </li>
                  <li>
                    <b>Düzenleyici</b>—etkinliğini yürütmek ve erişim/materyal/sertifika sağlamak için katılımcılara
                    ilişkin verileri alır (ör. ad/e-posta/durum).
                  </li>
                  <li>
                    <b>Yetkili makamlar</b>—yasal zorunluluk halinde.
                  </li>
                </ul>

                <h3>7) Uluslararası aktarımlar</h3>
                <p>
                  Bazı alıcılar (ör. Stripe, Zoom, Google, Meta) verileri AB/AEA dışında işleyebilir. Bu aktarımlarda
                  GDPR kapsamında uygun güvenceler (ör. Standart Sözleşme Maddeleri) uygulanır.
                </p>

                <h3>8) Saklama süreleri</h3>
                <ul>
                  <li>
                    <b>Hesap verileri</b>—hesap aktif olduğu sürece ve talepler karşısında koruma için kapanıştan
                    sonra en fazla 3 yıl, yasa başka bir süre öngörmedikçe.
                  </li>
                  <li>
                    <b>Muhasebe/vergi belgeleri</b> (faturalar, işlemler)—Bulgaristan hukukuna göre (genelde en fazla
                    10 yıl).
                  </li>
                  <li>
                    <b>Güvenlik günlükleri</b>—genelde en fazla 12 ay, olay/itiraz hariç.
                  </li>
                  <li>
                    <b>Pazarlama (rıza)</b>—rızanın geri çekilmesine kadar.
                  </li>
                </ul>

                <h3>9) Güvenlik</h3>
                <p>
                  Teknik ve örgütsel önlemler uygularız (trafik şifreleme, erişim kontrolü, izleme vb.). Hiçbir yöntem
                  mutlak güvenlik garanti etmez.
                </p>

                <h3>10) Haklarınız</h3>
                <ul>
                  <li>Erişim ve verilerin kopyası hakkı.</li>
                  <li>Yanlış/eksik verilerin düzeltilmesi hakkı.</li>
                  <li>
                    Yasada öngörülen hallerde silinme („unutulma”) hakkı.
                  </li>
                  <li>İşlemenin kısıtlanması hakkı.</li>
                  <li>Taşınabilirlik hakkı.</li>
                  <li>
                    İtiraz hakkı (uygulanabilir olduğunda pazarlamaya karşı dahil).
                  </li>
                  <li>
                    İşleme rızaya dayanıyorsa rızayı istediğiniz zaman geri çekme hakkı.
                  </li>
                </ul>
                <h4>Ayrıntı: GDPR kapsamında silme</h4>
                <p>
                  KVKK ve GDPR kapsamında uygulanabilir olduğu ölçüde Eventa.tv hesabınızla ilişkili kişisel verilerin
                  silinmesini talep edebilirsiniz („unutulma hakkı”). Başvuru yolları, bu Politikanın başındaki{' '}
                  <b>„Verilerinizin silinmesini nasıl talep edersiniz”</b> bölümüyle aynıdır.
                </p>
                <p><b>Hatırlatma — başvuru:</b></p>
                <ol>
                  <li>
                    <b>E-posta:</b>{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> veya{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> adresine, hesabınızda kayıtlı e-posta ile (veya
                    başvuruda kayıtlı e-postayı belirterek) yazın. Konu veya metinde{' '}
                    <b>hesabınızın ve ilişkili kişisel verilerin silinmesini</b> istediğinizi açıkça belirtin.
                  </li>
                  <li>
                    <b>İletişim bölümü:</b> eventa.tv üzerindeki „İletişim” bölümünü kullanarak silme talebinizi
                    açıklayabilirsiniz.
                  </li>
                </ol>
                <p>
                  Kimliğinizi doğruladıktan sonra (gerekirse) talebi işler ve makul bir sürede — genellikle <b>30 takvim günü</b>
                  içinde — yanıtlarız; kanun farklı bir süre öngörüyorsa buna uyarız. Muhasebe, vergi veya hukuki nedenlerle
                  belirli verileri saklamamız gerekirse sizi bilgilendiririz.
                </p>
                <p>
                  Facebook veya başka bir sağlayıcı ile giriş yaptıysanız, ilgili hizmetin gizlilik ayarlarından uygulama ve
                  izinleri yönetebilirsiniz; <b>bu, Eventa.tv’de tuttuğumuz verilerin silinmesinin yerine geçmez</b> — yukarıdaki
                  e-posta veya iletişim formunu kullanın.
                </p>
                <p>
                  Diğer haklarınız için: eventa.tv „İletişim” bölümünü kullanın veya yukarıdaki adrese yazılı başvuru gönderin.
                  Veri sorumlusu olarak Düzenleyici tarafından işlenen veriler için (ör. belirli bir etkinlik) doğrudan onunla
                  iletişime geçin.
                </p>

                <h3>11) Şikayetler</h3>
                <p>
                  Kişisel Verileri Koruma Komisyonu’na (CPDP), www.cpdp.bg şikayette bulunma hakkınız vardır. Önce
                  bizimle iletişime geçmenizi öneririz.
                </p>

                <h3>12) Çocukların verileri</h3>
                <p>
                  Platform 16 yaşın altındaki çocuklara yönelik değildir. Geçerli bir dayanak olmadan 16 yaşın altındaki
                  bir kişiye ait veri topladığımızı düşünüyorsanız bizimle iletişime geçin.
                </p>

                <h3>13) Değişiklikler</h3>
                <p>
                  Politikayı güncelleyebiliriz. Değişiklikler bu sayfada yayınlanır; önemli değişikliklerde platform/e-posta
                  ile bildirim yapılabilir.
                </p>

                <h3>14) İletişim</h3>
                <p>
                  Gizlilikle ilgili sorular: eventa.tv „İletişim” bölümü veya posta ile: ATOMICA GROUP Ltd, Bulgaristan,
                  Veliko Tırnovo, Nikola Gabrovski Sokak 63-b.
                </p>
              </div>`,
  sv: `<div >
                <p class="meta">Senast uppdaterad: 1 maj 2026</p>

                <div class="intro">
                  Denna integritetspolicy („Policyn”) beskriver hur ATOMICA GROUP Ltd behandlar
                  personuppgifter vid användning av Eventa.tv—för besökare, registrerade användare,
                  arrangörer och deltagare i evenemang.
                </div>

                <h3>Hur du begär radering av dina uppgifter</h3>
                <p>
                  Du kan när som helst begära <b>radering av ditt konto och de personuppgifter</b> som Eventa.tv lagrar om
                  dig. Det omfattar uppgifter som samlats in vid registrering, inloggning med e-post eller vid användning av{' '}
                  <b>Facebook / Meta-inloggning</b>.
                </p>
                <p><b>Steg (välj ett sätt):</b></p>
                <ol>
                  <li>
                    <b>E-post:</b> skicka meddelande till{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> eller till{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> från den <b>e-postadress som är registrerad på ditt
                    konto</b> (eller ange den registrerade adressen tydligt i texten). Ange i ämne eller meddelande att du
                    begär <b>radering av ditt konto och tillhörande personuppgifter som Eventa.tv lagrar</b>. Föreslaget
                    ämne: <b>„Begäran om kontoradering — Eventa.tv”</b>.
                  </li>
                  <li>
                    <b>Kontaktformulär:</b> på eventa.tv, öppna sidan <b>Kontakt</b>, beskriv samma begäran och ange din
                    registrerade e-postadress.
                  </li>
                </ol>
                <p>
                  Efter att vi har verifierat din identitet (vid behov) behandlar vi begäran och svarar inom{' '}
                  <b>30 kalenderdagar</b>, om inte tillämplig lag kräver annat. Om vi måste behålla vissa uppgifter av
                  bokförings-, skatte- eller juridiska skäl informerar vi dig skriftligen.
                </p>
                <p>
                  <b>Facebook / Meta:</b> Om du endast tar bort Eventa.tv-appen under <b>Appar och webbplatser</b> i
                  Facebooks inställningar <b>raderas inte automatiskt</b> din Eventa.tv-profil eller de uppgifter vi har på
                  våra servrar. För att radera uppgifter som vi lagrar skickar du en begäran per e-post eller via
                  kontaktformuläret ovan.
                </p>

                <h3>1) Personuppgiftsansvarig och omfattning</h3>
                <p>
                  Personuppgiftsansvarig för plattformen Eventa.tv är <b>ATOMICA GROUP Ltd</b>,
                  organisationsnummer (EIK) <b>205822763</b>, moms <b>BG205822763</b>, adress:
                  Bulgarien, Veliko Tarnovo, Nikola Gabrovski-gatan 63-b.
                </p>

                <h3>
                  2) Roller vid behandling (ansvarig/personuppgiftsbiträde)
                </h3>
                <ul>
                  <li>
                    För konton, säkerhet, plattformsadministration, betalningar/återbetalningar (via
                    Stripe), rapportering och fakturering: ATOMICA GROUP Ltd agerar som <b>ansvarig</b>.
                  </li>
                  <li>
                    För uppgifter om deltagare i specifika evenemang (t.ex. deltagarlistor, åtkomst till
                    privat sida, certifikat): ATOMICA GROUP Ltd kan agera som <b>personuppgiftsbiträde</b>
                    för Arrangören (som är ansvarig för dessa uppgifter), där tillämpligt.
                  </li>
                  <li>
                    <b>Stripe</b> behandlar betalnings- och kortdata som självständigt ansvarig; Eventa.tv
                    lagrar inte fullständiga kortuppgifter.
                  </li>
                  <li>
                    <b>Zoom</b>, <b>Google (Analytics)</b> och <b>Meta (Meta Pixel)</b> är självständigt
                    ansvariga för sina egna tjänster/teknologier (när de används/aktiveras).
                  </li>
                </ul>

                <h3>3) Vilka uppgifter vi samlar in</h3>
                <ul>
                  <li>
                    <b>Identifiering:</b> för- och efternamn, e-post, telefon (om lämnad).
                  </li>
                  <li>
                    <b>Profil:</b> lösenord (hashat), preferenser, språk, inställningar.
                  </li>
                  <li>
                    <b>Organisations-/faktureringsuppgifter (för arrangörer):</b> företag, EIK,
                    momsnummer, adress, faktureringsuppgifter, löpande fakturanummer (när det krävs för
                    dokumentation av utbetalning).
                  </li>
                  <li>
                    <b>Evenemangsrelaterat:</b> köpta biljetter, statusar (registrering/åtkomst/deltagande),
                    åtkomst till privat sida, utfärdade certifikat, köpta produkter.
                  </li>
                  <li>
                    <b>Betalning (ej kort):</b> betalningsstatus, belopp, valuta, transaktionsidentifierare,
                    återbetalningsdata, faktureringsdata. Kortdata behandlas av Stripe.
                  </li>
                  <li>
                    <b>Kommunikation:</b> korrespondens med support, systemmejl/aviseringar.
                  </li>
                  <li>
                    <b>Tekniska:</b> IP-adress, säkerhetsloggar, cookies/identifierare, webbläsare och session.
                  </li>
                </ul>

                <h3>4) Syften och rättsliga grunder</h3>
                <ul>
                  <li>
                    <b>Tillhandahålla tjänsten</b> (profil, evenemang, privata sidor, åtkomst,
                    certifikat)—<b>avtalets fullgörande</b>.
                  </li>
                  <li>
                    <b>Betalningar/återbetalningar/rapportering</b>, hantering av risk för bedrägeri/tvister—<b>avtalets
                    fullgörande</b> och/eller <b>berättigat intresse</b>.
                  </li>
                  <li>
                    <b>Fakturering och bokföring</b>—<b>rättslig förpliktelse</b>.
                  </li>
                  <li>
                    <b>Transaktionsmejl och påminnelser</b>—<b>avtalets fullgörande</b> och/eller <b>berättigat
                    intresse</b>.
                  </li>
                  <li>
                    <b>Säkerhet</b> och förebyggande av missbruk—<b>berättigat intresse</b>.
                  </li>
                  <li>
                    <b>Analys (Google Analytics)</b>—<b>samtycke</b> (via cookie-banner), när aktiverat.
                  </li>
                  <li>
                    <b>Marknadsföring/mätning (Meta Pixel)</b>—<b>samtycke</b>, när aktiverat.
                  </li>
                </ul>

                <h3>5) Cookies och liknande tekniker</h3>
                <p>
                  Vi använder nödvändiga cookies för webbplatsens funktion och, när du samtycker, analytiska
                  (Google Analytics) och annonserings- (Meta Pixel) cookies. Detaljer och hantering—i Eventa.tv:s
                  cookiepolicy.
                </p>

                <h3>6) Mottagare av uppgifter</h3>
                <ul>
                  <li>
                    <b>Stripe</b>—hantering av betalningar, återbetalningar, utbetalningar och relaterade
                    rapporteringsdata.
                  </li>
                  <li>
                    <b>Zoom</b>—genomförande av onlineevenemang (vid användning).
                  </li>
                  <li>
                    <b>
                      Leverantörer av infrastruktur/hosting/e-post/SMS/support
                    </b>
                    —för att tillhandahålla och underhålla tjänsten.
                  </li>
                  <li>
                    <b>Google/Meta</b>—vid givet samtycke för analytiska/marknadsföringssyften (när aktiverat).
                  </li>
                  <li>
                    <b>Arrangör</b>—tar emot uppgifter om deltagare till sitt evenemang (t.ex. namn/e-post/status)
                    för att genomföra evenemanget och tillhandahålla åtkomst/material/certifikat.
                  </li>
                  <li>
                    <b>Behöriga myndigheter</b>—vid lagkrav.
                  </li>
                </ul>

                <h3>7) Internationella överföringar</h3>
                <p>
                  Vissa mottagare (t.ex. Stripe, Zoom, Google, Meta) kan behandla data utanför EU/EES. Vid sådana
                  överföringar tillämpas lämpliga säkerhetsåtgärder enligt GDPR (t.ex. standardavtalsklausuler).
                </p>

                <h3>8) Lagringsperioder</h3>
                <ul>
                  <li>
                    <b>Kontouppgifter</b>—medan kontot är aktivt och upp till 3 år efter avslut för skydd mot
                    krav, om inte lagen kräver annat.
                  </li>
                  <li>
                    <b>Bokförings-/skattedokument</b> (fakturor, transaktioner)—enligt bulgarisk lag (vanligtvis
                    upp till 10 år).
                  </li>
                  <li>
                    <b>Säkerhetsloggar</b>—vanligtvis upp till 12 månader, om inte incident/tvist.
                  </li>
                  <li>
                    <b>Marknadsföring (samtycke)</b>—tills samtycke återkallas.
                  </li>
                </ul>

                <h3>9) Säkerhet</h3>
                <p>
                  Vi tillämpar tekniska och organisatoriska åtgärder (kryptering av trafik, åtkomstkontroll,
                  övervakning m.m.). Ingen metod garanterar absolut säkerhet.
                </p>

                <h3>10) Dina rättigheter</h3>
                <ul>
                  <li>Rätt till tillgång och kopia av uppgifter.</li>
                  <li>Rätt till rättelse av felaktiga/ofullständiga uppgifter.</li>
                  <li>
                    Rätt till radering („rätten att bli bortglömd”) i de fall lagen föreskriver.
                  </li>
                  <li>Rätt till begränsning av behandling.</li>
                  <li>Rätt till dataportabilitet.</li>
                  <li>
                    Rätt att invända (inklusive mot marknadsföring, där tillämpligt).
                  </li>
                  <li>
                    Rätt att återkalla samtycke när som helst när behandlingen baseras på samtycke.
                  </li>
                </ul>
                <h4>Mer information: radering enligt GDPR</h4>
                <p>
                  Du kan begära radering av personuppgifter som är kopplade till ditt Eventa.tv-konto („rätten att bli
                  bortglömd”) när det är tillämpligt enligt GDPR. Sätten att lämna in en begäran är desamma som i avsnittet{' '}
                  <b>„Hur du begär radering av dina uppgifter”</b> i början av denna policy.
                </p>
                <p><b>Påminnelse — så skickar du en begäran:</b></p>
                <ol>
                  <li>
                    <b>E-post:</b> Skicka e-post till{' '}
                    <a href="mailto:support@eventa.tv">support@eventa.tv</a> eller till{' '}
                    <a href="mailto:info@eventa.tv">info@eventa.tv</a> från den e-postadress som är registrerad på
                    ditt konto (eller ange din registrerade e-post i begäran). Ange tydligt i ämne eller text att du vill
                    att ditt <b>konto och relaterade personuppgifter raderas</b>.
                  </li>
                  <li>
                    <b>Kontakt:</b> Du kan också använda avsnittet „Kontakt” på eventa.tv och beskriva din begäran om
                    radering där.
                  </li>
                </ol>
                <p>
                  Efter att vi har verifierat din identitet (vid behov) behandlar vi begäran och svarar inom skälig
                  tid—vanligtvis inom <b>30 kalenderdagar</b>, om inte lagen kräver eller tillåter annat. Om vi måste behålla vissa
                  uppgifter av bokförings-, skatte- eller juridiska skäl informerar vi dig.
                </p>
                <p>
                  Om du har loggat in med Facebook eller en annan leverantör kan du också hantera appen och behörigheter i
                  tjänstens integritetsinställningar; <b>det ersätter inte</b> en begäran till oss om att radera uppgifter som
                  finns i Eventa.tv—använd e-post eller kontaktformuläret ovan.
                </p>
                <p>
                  För att utöva övriga rättigheter: använd avsnittet „Kontakt” på eventa.tv eller skicka en skriftlig
                  begäran till adressen ovan. För uppgifter som behandlas av Arrangören som ansvarig (t.ex. för ett visst
                  evenemang), kontakta denne direkt.
                </p>

                <h3>11) Klagomål</h3>
                <p>
                  Du har rätt att lämna klagomål till kommissionen för skydd av personuppgifter (CPDP),
                  www.cpdp.bg. Vi rekommenderar att du först kontaktar oss.
                </p>

                <h3>12) Uppgifter om barn</h3>
                <p>
                  Plattformen riktar sig inte till barn under 16 år. Om du anser att vi har samlat in uppgifter om
                  en person under 16 utan giltig grund, kontakta oss.
                </p>

                <h3>13) Ändringar</h3>
                <p>
                  Vi kan uppdatera denna Policy. Ändringar publiceras på denna sida; vid väsentliga ändringar kan vi
                  meddela via plattformen/e-post.
                </p>

                <h3>14) Kontakt</h3>
                <p>
                  Frågor om integritet: avsnittet „Kontakt” på eventa.tv eller per post: ATOMICA GROUP Ltd, Bulgarien,
                  Veliko Tarnovo, Nikola Gabrovski-gatan 63-b.
                </p>
              </div>`,
}
